import client from '../client';

export const readIdeaList = ({ year, category, status, page, pagesize, keyword } = {}) =>
    client.get('/api/idea/list', {
        params: {
            year: year || null,
            category: category || null,
            status: status || null,
            keyword: keyword?.trim() || null,
            page: page || 1,
            pagesize: pagesize || 20
        }
    });

export const readIdeaYears = () =>
    client.get('/api/idea/years');

export const readIdeaDetail = ({ ideaId }) =>
    client.get(`/api/idea/${ideaId}`);
